import React from 'react'
import GoogleInputField from '../google-input-field.jsx'
import CounterFieldNrRooms from '../counter-field-nr-rooms.jsx'
import MobileDropdown from '../mobile-dropdown.jsx'
import DatePicker from '../date-picker.jsx'
import moment from 'moment'

class MobileSearchBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hiddenInBlog: true
    }
    this.setBlogVisibility = this.setBlogVisibility.bind(this)
  }
  setBlogVisibility() {
    this.setState({ hiddenInBlog: false })
  }
  render() {
    const t = this.props.t
    return (
      <div className="mobile-search-box">
        <div className="mobile-search-box__top-section">
          <span className="mobile-search-box__title">
            Book the best accessible accommodations
          </span>
          <a className="mobile-search-box__call-us" href="tel:+44 1550 400022">
            Call us <b>NOW</b> if you need help <span className="mobile-search-box__call-us-small">(Local UK rate)</span>
          </a>
        </div>
        <div className={this.state.hiddenInBlog ? "mobile-search-box__form-section search-hidden-in-blog" : "mobile-search-box__form-section"}>
          <GoogleInputField
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            value={this.props.searchQuery}
            onChange={this.props.onSearchQueryChange}
            onReceivedSearchResults={this.props.onReceivedSearchResults}
            placeholder={t('landing_page_search_placeholder')}
            locale={this.props.state.locale}
            hideInBlog={this.setBlogVisibility}
          />
          <MobileDropdown
            onChange={this.props.onMobilityClassChange}
            value={this.props.mobilityClass}
          />

          <DatePicker
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            onDatesChange={this.props.onDatesChange}
            smallScreen={true}
            futureOnly="1"
          />

          <CounterFieldNrRooms
            postfix={'Guests'}
            onChange={this.props.onChangeRoomsData}
            value={this.props.nrGuests}
            minimumValue={1}
          />

          <button className="blue-large" onClick={this.props.onSearchClick}>
            {t('general_search')}
          </button>
        </div>
        <div className="blog-menu-arrow-wrapper">
          <button onClick={() => { this.setState({ hiddenInBlog: !this.state.hiddenInBlog }) }}
            style={{ transform: !this.state.hiddenInBlog ? 'rotate(180deg)' : 'rotate(0deg)' }}>
            <img src={require(`../../images/misc/see-more-arrow-blue.svg`)} alt="Menu collapse/expand arrow" />
          </button>
        </div>
      </div>

    )
  }
}

export default MobileSearchBox